module.exports = __webpack_public_path__ + "img/equip_2.15fc9388.png";